<template>
  <v-card
    width="100%"
    height="auto"
    flat
  >
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-row class="mx-0">
        <v-col
          cols="12"
        >
          <v-text-field
            v-model="invoiceSubtitle"
            :label="$t('invoiceSubtitle')"
            :rules="[v => !!v || $t('is-required')]"
            outlined
            placeholder=""
            clearable
            hide-details
            dense
          />
        </v-col>
        <v-col
          cols="12"
          class="my-0 py-0"
          style="height: auto !important;"
        >
          <tiptap-vuetify
            v-model="invoiceContent"
            :extensions="extensions"
            :toolbar-attributes="{ color: '#ababab', dark: true }"
          />
        </v-col>
      </v-row>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="$emit('close')"
            >
              {{ $t('cancel') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>
<script>
  // import aicomplete from '../../components/general/AIcomplete/index'
  import General from '../../../../../Mixins/general'
  import {
    // component
    TiptapVuetify,
    // extensions
    Heading,
    Bold,
    Italic,
    Strike,
    Underline,
    Code,
    Paragraph,
    BulletList,
    OrderedList,
    ListItem,
    Link,
    Blockquote,
    HardBreak,
    HorizontalRule,
    History,
    Image,
    Table,
    TableCell,
    TableHeader,
    TableRow,
  } from 'tiptap-vuetify'
  export default {
    name: 'Customer',
    components: {
      TiptapVuetify,
    },
    mixins: [General],
    data: () => ({
      valid: true,
      extensions: [
        History,
        Table,
        TableCell,
        TableHeader,
        TableRow,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem, // if you need to use a list (BulletList, OrderedList)
        BulletList,
        OrderedList,
        Image,
        [
          Heading,
          {
            // Options that fall into the tiptap's extension
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak, // line break on Shift + Ctrl + Enter
      ],
      invoiceSubtitle: null,
      invoiceContent: null,
      paymentZibalSystem: null,
      paymentZibalAccountName: null,
      paymentZibalAccountShaba: null,
      paymentZibalConfirm: false,
      select: 'invoicePrint',
      lists: [],
      render: false,
      isLoading: false,
    }),
    watch: {
    },
    activated () {
      this.show()
    },
    beforeMount () {
      this.statusItems = [
        {
          value: 'not_completed',
          text: this.$t('not_completed'),
        },
        {
          value: 'canceled',
          text: this.$t('canceled'),
        },
        {
          value: 'not_completed',
          text: this.$t('not_completed'),
        },
        {
          value: 'unfulfilled',
          text: this.$t('unfulfilled'),
        },
        {
          value: 'fulfilled',
          text: this.$t('fulfilled'),
        },
      ]
    },
    mounted () {
      this.show()
    },
    methods: {
      addPaymentMethod () {
        this.paymentItems.push({
          bank: null,
          value: null,
        })
      },
      remove (index) {
        this.paymentItems.splice(index, 1)
      },
      create () {
        if (!this.$refs.form.validate()) return false
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'setting', this.$data)
          .then(res => {
            app.snakbarText = app.$t('registered')
            app.snakbarColor = 'green'
            app.snakbar = true
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      show () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'setting/' + 1 + '/edit', {
          params: {
            select: app.select,
          },
        })
          .then(res => {
            app.$nextTick(() => {
              res = res.data
              app.invoiceContent = res.content
              app.invoiceSubtitle = res.subtitle
              app.render = true
            })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      copied () {
        this.snakbarText = this.$t('copied')
        this.snakbarColor = 'blue'
        this.snakbar = true
      },
      // generatePDF () {
      //   const columns = [
      //     { title: 'ایسن', dataKey: 'title' },
      //     { title: 'Body', dataKey: 'body' },
      //   ]
      //   const doc = new Jspdf({
      //     orientation: 'portrait',
      //     unit: 'in',
      //     format: 'letter',
      //   })
      //   // doc.setFont('IRANSans', 'normal', 'bold')
      //   doc.setLanguage('ar')
      //   // text is placed using x, y coordinates
      //   doc.setFontSize(16).text(this.heading, 0.5, 1.0)
      //   // create a line under heading
      //   doc.setLineWidth(0.01).line(0.5, 1.1, 8.0, 1.1)
      //   // Using autoTable plugin
      //   autoTable(doc, {
      //     columns,
      //     body: this.items,
      //     margin: { left: 0.5, top: 1.25 },
      //   })
      //   // Using array of sentences
      //   doc
      //     .setFont('helvetica')
      //     .setFontSize(12)
      //     .text(this.moreText, 0.5, 3.5, { align: 'left', maxWidth: '7.5' })
      //
      //   // Creating footer and saving file
      //   doc.text(0, 10, 'Non-utf-8-string')
      //   doc
      //     // .setFont('times')
      //     // .setFontSize(11)
      //     // .setFontStyle('italic')
      //     // .setTextColor(0, 0, 255)
      //     // .text(
      //     //   'This is a simple footer located .5 inches from page bottom',
      //     //   0.5,
      //     //   doc.internal.pageSize.height - 0.5,
      //     // )
      //     .save(`${this.heading}.pdf`)
      // },
    },
  }
</script>

<style scoped>
.col{
  height: 55px !important;
}
</style>
